import type { TFunction } from 'i18next'
import {
  BulbIcon,
  FootIcon,
  SeaIcon,
  TreeIcon,
  MudIcon,
  SnowIcon,
  CowIcon,
  FoodIcon,
  BlockIcon,
  PetIcon,
  DishesIcon,
  BabyIcon,
  TiviIcon,
  DevelopIcon,
  PrimaryIcon,
  PhotoShareIcon,
  CarIcon,
  HomeTownIcon,
  SetPlanIcon,
  AllIcon,
} from './Icon'

export const categoryList = (t: TFunction) => {
  const jpe = document.documentElement.lang === 'en'

  const allCategories = [
    {
      id: 0,
      value: jpe ? t('top.category_list.top_picks') : t('top.category_list.all'),
      type: 'clear',
      icon: jpe ? BulbIcon : AllIcon,
    },
    {
      id: 1,
      value: t('top.category_list.summer_vacation'),
      type: 'feature',
      icon: BulbIcon,
    },
    {
      id: 2,
      value: t('top.category_list.walk_to_preschool'),
      type: 'room_environment',
      icon: FootIcon,
    },
    {
      id: 3,
      value: t('top.category_list.sea_play'),
      type: 'feature',
      icon: SeaIcon,
    },
    {
      id: 4,
      value: t('top.category_list.forest_play'),
      type: 'feature',
      icon: TreeIcon,
    },
    {
      id: 5,
      value: t('top.category_list.snow_play'),
      type: 'feature',
      icon: SnowIcon,
    },
    {
      id: 6,
      value: t('top.category_list.mud'),
      type: 'feature',
      icon: MudIcon,
    },
    {
      id: 7,
      value: t('top.category_list.food_education'),
      type: 'feature',
      icon: FoodIcon,
    },
    {
      id: 8,
      value: t('top.category_list.english_education'),
      type: 'feature',
      icon: BlockIcon,
    },
    {
      id: 9,
      value: t('top.category_list.elementary_ok'),
      type: 'service_type',
      icon: PrimaryIcon,
    },
    {
      id: 10,
      value: t('top.category_list.set_program'),
      type: 'service_type',
      icon: SetPlanIcon,
    },
    {
      id: 11,
      value: t('top.category_list.developmental_support'),
      type: 'feature',
      icon: DevelopIcon,
    },
    {
      id: 12,
      value: t('top.category_list.animal_contact'),
      type: 'feature',
      icon: CowIcon,
    },
    {
      id: 13,
      value: t('top.category_list.pets_allowed'),
      type: 'room_environment',
      icon: PetIcon,
    },
    {
      id: 14,
      value: t('top.category_list.stay_with_meals'),
      type: 'room_environment',
      icon: DishesIcon,
    },
    {
      id: 15,
      value: t('top.category_list.baby_friendly'),
      type: 'room_environment',
      icon: BabyIcon,
    },
    {
      id: 16,
      value: t('top.category_list.with_coworking'),
      type: 'room_environment',
      icon: TiviIcon,
    },
    {
      id: 17,
      value: t('top.category_list.preschool_photo_sharing'),
      type: 'feature',
      icon: PhotoShareIcon,
    },
    {
      id: 18,
      value: t('top.category_list.walkable_access'),
      type: 'feature',
      icon: CarIcon,
    },
    {
      id: 19,
      value: t('top.category_list.home_town'),
      type: 'feature',
      icon: HomeTownIcon,
    },
  ]

  return jpe ? allCategories.filter((category) => category.id === 0 || category.id === 9) : allCategories
}
